import { ConfigProvider } from 'antd';
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH, PUBLIC_PREFIX_PATH } from 'configs/AppConfig';
import useBodyClass from 'hooks/useBodyClass';
import AppLocale from 'lang';
import AppLayout from 'layouts/app-layout';
import AuthLayout from 'layouts/auth-layout';
import PublicLayout from 'layouts/public-layout';
import React, {useEffect} from 'react';
import { IntlProvider } from 'react-intl';
import { connect, useSelector } from 'react-redux';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { isUserLoggedIn } from 'redux/reducers/loggedInUser';

export const Views = (props) => {
  const { locale, location, direction } = props;
  const currentAppLocale = AppLocale[locale];
  localStorage.setItem("isPublic", false);   
  useBodyClass(`dir-${direction}`);
  const isLoggedIn = useSelector(isUserLoggedIn);

  useEffect(() => {
    const isUserFound = localStorage.getItem("loggedIN");
    if (isUserFound && window.Userback) {
      window.Userback.email = isUserFound;
      window.Userback.user_data = {
        info: {
          email: isUserFound,
        },
      };
    }
  }, []);

  return (
    <IntlProvider
      locale={currentAppLocale.locale}
      messages={currentAppLocale.messages}
    >
      <ConfigProvider locale={currentAppLocale.antd} direction={direction}>
        <Switch>
          <Route exact path="/">
            <Redirect to={APP_PREFIX_PATH} />
          </Route>
          <Route path={AUTH_PREFIX_PATH}>
            {isLoggedIn ? (
              <Redirect to={APP_PREFIX_PATH + "/home_new"} />
            ) : (
              <AuthLayout direction={direction} />
            )}
          </Route>
          <Route path={PUBLIC_PREFIX_PATH}>
            <PublicLayout direction={direction} />
          </Route>
          <Route path={APP_PREFIX_PATH}>
            {isLoggedIn ? (
              <AppLayout direction={direction} location={location} />
            ) : (
              <Redirect to={AUTH_PREFIX_PATH + "/login"} />
            )}

          </Route>
        </Switch>
      </ConfigProvider>
    </IntlProvider>
  );
};

const mapStateToProps = ({ theme, auth }) => {
  const { locale, direction } = theme;
  const { token } = auth;
  return { locale, token, direction };
};

export default withRouter(connect(mapStateToProps)(Views));
